<template>
  <el-dialog v-dialog-drag='{width: "80vw", height: "90vh", marginTop: "5vh", isFullscreen: false}'
             :title='dialogTitle' :visible.sync='dialogVisible' :close-on-click-modal='false'
             @close='dialogClose' width='1300px'>
    <el-row type='flex' justify='space-around'>
      <el-col :span='20' style='font-size: 14px!important;'>
        <el-button size='mini' class='searchBtn' :loading='submitLoading' @click='submit'>
          提交
        </el-button>
      </el-col>
      <el-col :span='4' style='font-size: 14px!important;text-align: end;' class='exportButton'>
        <span @click='exportData'>导出数据</span>
      </el-col>
    </el-row>
    <el-form :model='form' label-width='130px' label-position='right' ref='ruleForm'
             class='dialogForm formHeight mt10'>
      <el-table border :data='form.details' show-summary :summary-method='getSummaries'
                v-loading='tableLoading' :span-method='objectSpanMethod'>
        <el-table-column label='供应商名称' align='center'>
          <el-table-column label='项目' prop='moduleName' align='center' width='100' />
        </el-table-column>
        <el-table-column :label='formData.supplierName' align='center'>
          <el-table-column label='' prop='examineTarget' align='center' width='100'
                           :formatter='examineTargetFormat' />
          <el-table-column label='指标与权重' prop='targetWeight' align='center' width='100' />
          <el-table-column label='目标值' prop='targetValue' align='center' />
          <el-table-column label='分子实际数' align='center' width='100'>
            <template slot-scope='scope'>
              <div v-if='scope.row.examineTarget === "1"'>--</div>
              <div v-else-if='scope.row.numeratorType === "1" '>{{ scope.row.numerator }}</div>
              <el-input v-else size='mini' type='number'
                        v-model='form.details[scope.$index].numerator' />
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label='考核时间' align='center'>
          <el-table-column label='分母实际数' align='center' width='100'>
            <template slot-scope='scope'>
              <div v-if='scope.row.examineTarget === "1"'>--</div>
              <div v-else-if='scope.row.denominatorType === "1"'>{{ scope.row.denominator }}</div>
              <el-input v-else size='mini' type='number'
                        v-model='form.details[scope.$index].denominator' />
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column :label='formData.examineTimeStr' align='center'>
          <el-table-column label='实际值' prop='actualValue' align='center'>
            <template slot-scope='scope'>
              <div v-if='scope.row.examineTarget === "1"'>--</div>
              <div v-else>{{ actualValueFormat(scope.row, {}, {}, scope.$index) }}</div>
            </template>
          </el-table-column>
          <el-table-column label='评分标准' align='left' width='400'>
            <template slot-scope='scope'>
              <div v-html='scope.row.scoringCriteria'></div>
            </template>
          </el-table-column>
          <el-table-column label='实际得分' prop='actualScore' align='center' min-width='160'>
            <template slot-scope='scope'>
              <div v-if='scope.row.examineTarget === "1"'>
                <el-input-number size='mini' :max='5  ' :min='1'
                                 v-model='form.details[scope.$index].actualScore' />
              </div>
              <div v-else>{{ actualScoreFormat(scope.row, {}, {}, scope.$index) }}</div>
            </template>
          </el-table-column>
          <el-table-column label='备注' prop='remarks' align='center' width='200'>
            <template slot-scope='scope'>
              <el-input type='textarea' size='mini'
                        v-model='form.details[scope.$index].remarks' />
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </el-form>
  </el-dialog>
</template>

<script>
  import BatchImport from '@/components/batchImport';
  import DivBorder from '@/components/divBorder';
  import { getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';
  import { monthlyAssessmentInfo, monthlyAssessmentSubmit } from '@/service/supplierAssessment';

  export default {
    name: 'monthlyAssessmentDetails',
    components: {
      BatchImport,
      DivBorder,
    },
    data() {
      return {
        dialogVisible: false,
        dialogTitle: '新增',
        defaultForm: {},
        tableLoading: false,
        form: {
          id: '',
          details: [],
        },
        submitLoading: false,
        formData: {},
      };
    },
    mounted() {
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
    },
    methods: {
      examineTargetFormat(r, c, cellValue) {
        switch (cellValue) {
          case '0':
            return 'KPI指标';
          case '1':
            return '物流综合服务能力';
        }
      },
      actualValueFormat(row, cell, cellValue, index) {
        this.form.details[index].actualValue = ['Infinity', 'NaN'].includes((row.numerator / row.denominator).toFixed(2)) ? 0 : (row.numerator / row.denominator).toFixed(5) * 100;
        return ['Infinity', 'NaN'].includes((row.numerator / row.denominator).toFixed(2)) ? 0 : (row.numerator / row.denominator).toFixed(5) * 100 + '%';
      },
      actualScoreFormat(row, cell, cellValue, index) {
        let score = 0;
        row.scList.forEach(item => {
          if (item.startPrice <= row.actualValue && row.actualValue <= item.endPrice) {
            score = item.score;
          }
        });
        this.form.details[index].actualScore = score;
        return score;
      },
      // 合并相同列
      objectSpanMethod({
                         row,
                         column,
                         rowIndex,
                         columnIndex,
                       }) {
        // data ：需要修改的列数和列的属性 第一列从0开始
        const data = [
          {
            columnIndex: 0,
            value: 'moduleName',
          },
          {
            columnIndex: 1,
            value: 'examineTarget',
          },
        ];
        for (let index = 0; index < data.length; index++) {
          if (columnIndex === data[index].columnIndex) {
            const _row = this.filterData(this.form.details, data[index].value)[rowIndex];
            const _col = _row > 0 ? 1 : 0;
            return {
              rowspan: _row,
              colspan: _col,
            };
          }
        }
      },
      // 根据是否有相同数据返回一个如[2,0,3,0,0]格式的数组(公共的)
      filterData(arr, value) {
        let spanOneArr = [];
        let concatOne = 0;
        arr.forEach((item, index) => {
          if (index === 0) {
            spanOneArr.push(1);
          } else {
            // name 修改
            if (item[value] === arr[index - 1][value]) {
              spanOneArr[concatOne] += 1;
              spanOneArr.push(0);
            } else {
              spanOneArr.push(1);
              concatOne = index;
            }
          }
        });
        return spanOneArr;
      },
      getSummaries(param) {
        const {
          columns,
          data,
        } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计得分';
            return;
          }
          if (index === 7) {
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
            }
          }
        });
        return sums;
      },
      async rowFormat(row) {
        this.formData = row;
        this.form.id = row.id;
        this.tableLoading = true;
        const {
          status,
          message,
          data,
        } = await monthlyAssessmentInfo(row.id);
        this.tableLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.form.details = data;
      },
      dialogOpen(title, row) {
        this.dialogTitle = title;
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
        if (row) this.rowFormat(row);
        this.dialogVisible = true;
      },
      dialogClose() {
        this.dialogVisible = false;
      },
      submit() {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            this.submitLoading = true;
            const {
              status,
              message,
            } = await monthlyAssessmentSubmit(this.form);
            this.submitLoading = false;
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            this.dialogClose();
            this.$emit('searchBtn');
          }
        });
      },
      // 导出数据
      exportData() {
        let token = getSessionStore('token');
        window.location.href = `${baseUrl}/platform/supplierMonthExamineManage/exportMonthExamineDetail/${this.form.id}?access_token=${token}`;
      },
    },
  };
</script>

<style lang='scss' scoped>
  .dialogForm {
    margin: 0 auto;
  }

  ::v-deep {
    .el-form-item__content .el-input-group {
      vertical-align: revert;
    }
  }
</style>
